import React from 'react';
import {
  IconCalendarTime,
  IconCalendarEvent,
  IconClock,
} from '@tabler/icons-react';
import { TextWithEmoji } from '@shared/ui/text-with-emoji/text-with-emoji';
import { formatSlotDate } from '@entities/messanger';
import { useProfile } from '@shared/api/useProfile';
import { OfferCard } from './offer-card';
import s from './interactive-message.module.scss';

// Fallback-рендер предложения слота по payload (пока сообщение pending
// и серверный card ещё не пришёл) — тот же layout и детали, что у
// SlotOfferEntityCard, только без статуса и кнопок.
export const SlotOfferCard = ({ message, isMine }) => {
  const { data: profile } = useProfile();
  const payload = message.payload || {};

  const date = formatSlotDate(payload.date, profile?.timezone);
  const time = payload.time;
  const instrumentName = payload.instrument_name || payload.instrument;

  return (
    <>
      <OfferCard
        icon={<IconCalendarTime size={20} />}
        title="Предложение занятия"
        message={message}
      >
        <div className={s.chips}>
          {date && (
            <span className={s.chip}>
              <IconCalendarEvent size={14} />
              {date}
            </span>
          )}
          {time && (
            <span className={s.chip}>
              <IconClock size={14} />
              {time}
            </span>
          )}
          {instrumentName && (
            <span className={s.chip}>
              <TextWithEmoji text={instrumentName} />
            </span>
          )}
        </div>
      </OfferCard>
      {isMine && <span className={s.statusText}>Отправлено ученику</span>}
    </>
  );
};
